import { useEffect, useState } from "react";
import { message } from "antd";
import { serverFetch } from "../../server";
import CompaniesList from "./companies-list";
import MessagePatterns from "./message-patterns";

const Companies = ({ page }) => {
  const getPage = () => {
    switch (page) {
      case "message-patterns":
        return <MessagePatterns />;
      case "companies":
      default:
        return <CompaniesList />;
    }
  };

  const getItem = (title, link) => (
    <a
      className={"col-one-title-item" + (link === page ? " col-one-title-selected " : "")}
      href={`/${link}`}
    >
      {title}
    </a>
  );

  return (
    <div className="col-one-main">
      <div className="col-one-title">
        {getItem("Компании", "companies")}
        {getItem("Шаблоны сообщений", "message-patterns")}
      </div>
      <div className="col-one-col">{getPage()}</div>
    </div>
  );
};

export default Companies;
